


















import { isNumber } from "lodash";
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import Card, { NextCardDirection } from "./Card.vue";
import Control from "./Control.vue";

@Component({ components: { Card, Control } })
export default class CellRegenerationRateCard extends Vue {
  @Prop({ required: true })
  private nextCardDirection: NextCardDirection;

  @Prop({ required: true })
  private pointerAnimationDuration: number;

  @Prop({ required: true })
  private cellRegenerationRate: number;

  private get minRegenerationRate() {
    return 500;
  }

  private get maxRegenerationRate() {
    return 10000;
  }

  private isValidRegenerationRate(cellRegenerationRate: number) {
    return isNumber(cellRegenerationRate)
      && cellRegenerationRate >= this.minRegenerationRate
      && cellRegenerationRate <= this.maxRegenerationRate;
  }
}
